module.exports = __webpack_public_path__ + "static/media/matnrrd_3-360w.0ad99db4.png";